import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Assignment from '@mui/icons-material/Assignment';
import { CollapseCard } from '@totalsoft/rocket-ui';
import FolderGeneralInfoSummary from './FolderGeneralInfoSummary';
import FolderGeneralInfoComponent from './FolderGeneralInfoComponent';

const FolderGeneralInfoCard = ({
  generalInfo,
  t,
  savingGeneralInfo,
  onSave,
  isDirty,
  validation,
  isNewFolder,
  onGeneralInfoChange,
  accountManagersOptions,
  responsiblesOptions,
  partnersOptions,
  folderTypes,
  openLinkedDocument,
  onCalculateApproval,
  isFacilityApproval
}) => {
  const [expanded, setExpanded] = useState(isNewFolder);
  const toggleExpanded = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  return (
    <CollapseCard
      icon={Assignment}
      iconColor='primary'
      title={t('Folder.GeneralData.GeneralInfo.Title')}
      expanded={expanded}
      onToggle={toggleExpanded}
      subheader={<FolderGeneralInfoSummary generalInfo={generalInfo} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      <FolderGeneralInfoComponent
        generalInfo={generalInfo}
        onGeneralInfoChange={onGeneralInfoChange}
        onSave={onSave}
        savingGeneralInfo={savingGeneralInfo}
        isDirty={isDirty}
        validation={validation}
        isNewFolder={isNewFolder}
        accountManagersOptions={accountManagersOptions}
        responsiblesOptions={responsiblesOptions}
        partnersOptions={partnersOptions}
        folderTypes={folderTypes}
        openLinkedDocument={openLinkedDocument}
        onCalculateApproval={onCalculateApproval}
        isFacilityApproval={isFacilityApproval}
      />
    </CollapseCard>
  );
};

FolderGeneralInfoCard.propTypes = {
  generalInfo: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  savingGeneralInfo: PropTypes.bool,
  onGeneralInfoChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  validation: PropTypes.object,
  isNewFolder: PropTypes.bool,
  accountManagersOptions: PropTypes.array.isRequired,
  responsiblesOptions: PropTypes.array.isRequired,
  partnersOptions: PropTypes.array.isRequired,
  folderTypes: PropTypes.array.isRequired,
  onCalculateApproval: PropTypes.func.isRequired,
  openLinkedDocument: PropTypes.func,
  isFacilityApproval: PropTypes.bool
};

export default withTranslation()(FolderGeneralInfoCard);
